import { render } from "./CreatePortabilityRequestDialog.vue?vue&type=template&id=7dc7c353"
import script from "./CreatePortabilityRequestDialog.vue?vue&type=script&lang=js"
export * from "./CreatePortabilityRequestDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__